import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

interface IJudgeMeContext {
  isLoaded: boolean;
  reload: () => void;
}

const JudgeMeContext = createContext<IJudgeMeContext | null>(null);

type JudgeMeProviderProps = {
  children: ReactNode;
};

declare global {
  interface Window {
    jdgmCacheServer: any;
  }
}

export const JudgeMeProvider: React.FC<JudgeMeProviderProps> = ({children}) => {
  const hasBeenInitiated = useRef(false);
  const [script1, setScript1] = useState(false);
  const [script2, setScript2] = useState(false);

  const isLoaded = script1 && script2;

  function reloadWidgets() {
    if (isLoaded && window.jdgmCacheServer) {
      // This will trigger all widgets to reload
      window.jdgmCacheServer.reloadAll();
    }
  }

  useEffect(() => {
    function loadJudgeMeScripts() {
      if (hasBeenInitiated.current) {
        return;
      }
      hasBeenInitiated.current = true;

      document.addEventListener('jdgm.doneSetup', () => {
        // This is a callback to when jdgm has finished setting up a widget.
        // console.log('Finished setup');
      });

      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = 'https://cdn.judge.me/';
      document.head.appendChild(link);

      const configScript = document.createElement('script');
      configScript.dataset.judgeMe = 'true';
      configScript.innerHTML = `
        jdgm = window.jdgm || {};
        jdgm.SHOP_DOMAIN = 'safeback-9075.myshopify.com';
        jdgm.PLATFORM = 'shopify';
        jdgm.PUBLIC_TOKEN = 'qBdYH0Bm9IRNbN__LtddLbTwZNg';
        `;

      document.head.appendChild(configScript);

      const script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.async = true;
      script2.setAttribute('src', 'https://cdn.judge.me/widget_preloader.js');
      script2.onload = function () {
        setScript1(true);
      };
      document.head.appendChild(script2);

      const script3 = document.createElement('script');
      script3.type = 'text/javascript';
      script3.async = true;
      script3.setAttribute('src', 'https://cdn.judge.me/assets/installed.js');
      script3.onload = function () {
        setScript2(true);
      };
      document.head.appendChild(script3);
    }

    loadJudgeMeScripts();
  }, []);
  return (
    <JudgeMeContext.Provider value={{reload: reloadWidgets, isLoaded}}>
      {children}
    </JudgeMeContext.Provider>
  );
};

export const useJudgeMe = () => {
  const context = useContext(JudgeMeContext);
  if (context === undefined || context === null) {
    throw new Error('useScripts must be used within a JudgeMeProvider');
  }
  return context;
};
